import React from 'react';
import { OASIS_CATALOG } from '../common/oasisCatalog.js';

export default function OasisCard({ oasisId, palmTreeOwnerIds = [], selectable, selected, winner, onClick }) {
  const { value, isPortal } = OASIS_CATALOG[oasisId];
  const hasMine = palmTreeOwnerIds.includes('me');
  const hasOpponent = palmTreeOwnerIds.includes('opponent');

  const classNames = ['oasis-card', isPortal ? 'oasis-card-portal' : 'oasis-card-normal'];
  if (selectable) classNames.push('oasis-card-selectable');
  if (selected) classNames.push('oasis-card-selected');
  if (winner === 'my') classNames.push('oasis-card-won');

  return (
    <div className={classNames.join(' ')} onClick={selectable ? onClick : undefined}>
      {isPortal && (
        <>
          <div className="oasis-card-arrow oasis-card-arrow-tl">↑</div>
          <div className="oasis-card-arrow oasis-card-arrow-tr">↑</div>
          <div className="oasis-card-arrow oasis-card-arrow-bl">↓</div>
          <div className="oasis-card-arrow oasis-card-arrow-br">↓</div>
        </>
      )}
      {hasOpponent && <div className="oasis-card-palm-tree oasis-card-palm-tree-top" title="Opponent's palm tree">🌴</div>}
      <div className="oasis-card-value-frame">
        <div className={`oasis-card-value-badge ${value < 0 ? 'oasis-card-value-badge-negative' : 'oasis-card-value-badge-positive'}`}>
          <div className="oasis-card-value">{value}</div>
        </div>
      </div>
      {hasMine && <div className="oasis-card-palm-tree oasis-card-palm-tree-bottom" title="Your palm tree">🌴</div>}
    </div>
  );
}
